const THEME_COLORS = ["speeke", "blue", "green"] as const
const THEME_MODES = ["light", "dark"] as const

const DEFAULT_THEME_MODE = "light"
const DEFAULT_THEME_COLOR = "speeke"

type ThemeColor = (typeof THEME_COLORS)[number]
type ThemeMode = (typeof THEME_MODES)[number]

export interface ThemeConfig {
  mode: ThemeMode
  color: ThemeColor
}

// Carregar tema do localStorage ou usar padrão
export function getTheme(): ThemeConfig {
  if (typeof window === "undefined") {
    return { mode: DEFAULT_THEME_MODE, color: DEFAULT_THEME_COLOR }
  }

  const storedTheme = localStorage.getItem("current-theme")
  if (storedTheme) {
    try {
      return JSON.parse(storedTheme)
    } catch {
      // Em caso de erro, retorna o tema padrão
      return { mode: DEFAULT_THEME_MODE, color: DEFAULT_THEME_COLOR }
    }
  }

  // Verificar se o sistema prefere dark mode
  // const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
  return {
    // mode: prefersDark ? "dark" : "light",
    mode: DEFAULT_THEME_MODE,
    color: DEFAULT_THEME_COLOR,
  }
}

// Salvar tema no localStorage
export function setTheme(theme: ThemeConfig): void {
  if (typeof window === "undefined") {
    return
  }

  // Salvar no localStorage
  localStorage.setItem("current-theme", JSON.stringify(theme))

  // Aplicar no DOM
  applyTheme(theme)
}

// Aplicar classes no elemento html
export function applyTheme(theme: ThemeConfig): void {
  if (typeof document === "undefined") {
    return
  }

  const root = document.documentElement

  // Aplicar modo (light/dark)
  if (theme.mode === "dark") {
    root.classList.add("dark")
  } else {
    root.classList.remove("dark")
  }

  // Limpar classes de tema de cor anteriores
  Object.values(THEME_COLORS).forEach(color => {
    root.classList.remove(`theme-${color}`)
  })

  // Aplicar tema de cor (se não for o padrão)
  root.classList.add(`theme-${theme.color}`)
}

// Inicializar tema ao carregar a aplicação
export function initializeTheme(): void {
  const theme = getTheme()
  applyTheme(theme)
}
